import type { TranslationContent } from '@CS/components/TranslationProvider/types';
import type { UseFormRegisterReturn } from 'react-hook-form';
import type { ChangeEvent, SyntheticEvent } from 'react';

import { Content } from '@CS/components/Form';
import { useTranslation } from '@CS/hooks';
import { isIOS } from '@CS/utils/Device';

import {
  FieldError,
  FieldInput,
  FieldLabel,
  FieldContainer
} from './InputField.styles';

type InputFieldProps = {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  setFocus?: (focus: boolean) => void;
  register?: UseFormRegisterReturn;
  onClick?: () => void;
  placeholder?: string;
  fieldError?: string;
  onBlur?: () => void;
  maxlength?: number;
  disabled?: boolean;

  error?: boolean;
  width?: number;
  value?: string;
  label?: string;

  last?: boolean;
  type?: string;
  name: string;
};

export const InputField = ({
  disabled = false,
  placeholder = '',
  fieldError = '',

  error = false,
  type = 'text',
  last = false,
  width = 100,

  maxlength,
  setFocus,
  onChange,
  register,
  onClick,

  onBlur,
  label,
  value,
  name
}: InputFieldProps) => {
  const Translations = Content as TranslationContent;
  const fieldLabel = useTranslation(Translations[name]);
  fieldError ||= useTranslation(Translations[`${name}Error`]);

  const onFocus = () => {
    if (isIOS) return;

    setFocus && setFocus(true);
  };

  const onBlurHandler = (event: SyntheticEvent) => {
    setFocus && setFocus(false);

    if (onBlur) onBlur();
    else if (register?.onBlur) register.onBlur(event);

    const Element = document.getElementById('app-wrapper');
    if (Element) Element.style.paddingBottom = '';
  };

  return (
    <FieldContainer width={width} last={last}>
      <FieldLabel htmlFor={name}>{label || fieldLabel}</FieldLabel>

      <FieldInput
        id={name}
        type={type}
        {...register}
        value={value}
        onFocus={onFocus}
        onClick={onClick}
        autoComplete="off"
        disabled={disabled}
        maxLength={maxlength}
        onBlur={onBlurHandler}
        placeholder={placeholder}
        onChange={onChange || register?.onChange}
      />

      {error && <FieldError>{fieldError}</FieldError>}
    </FieldContainer>
  );
};
